import { useDisclosure } from "@chakra-ui/react"
import { IconButton } from "components"
import { Json } from "screens"

const debug = localStorage.getItem('@debug') === '1'

export default function Dev({ data = {}, ...props }){

    const dev = useDisclosure()

    if(!debug) return <></>

    return(
    <>
        <IconButton label="Informações para nerds" icon="dev" onClick={dev.onOpen} {...props} />
        <Json data={data} {...dev} />
    </>
    )
}